import { MenuItem, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { AgreementOptions, EntityFormValues } from "../../supportEntitiesTypes"
import { StandardAlertInfo } from "../../../../../../shared/components/alert/StandardAlertInfo"

const useStyles = makeStyles()(() => ({
    dropdownField: {
        width: "25%",
        minWidth: "10rem",
    },
}))

export function AgreementOwnerContent() {
    const { classes } = useStyles()

    return (
        <>
            <LocalizedStrict id="support-create-entity-agreement-owner-subtitle">
                <Typography mb="0.5rem" fontWeight={400}>
                    Agreement owner
                </Typography>
            </LocalizedStrict>
            <Stack direction="column" spacing=".5rem">
                <LocalizedStrict id="support-create-entity-type-choose-label" attrs={{ label: true }}>
                    <FormikDropdown<EntityFormValues>
                        className={classes.dropdownField}
                        label="Choose(*)"
                        name="isSystemOwner"
                    >
                        <MenuItem value={AgreementOptions.YES}>
                            <LocalizedStrict id="support-create-entity-dropdown-choose-yes">
                                <span>Yes</span>
                            </LocalizedStrict>
                        </MenuItem>
                        <MenuItem value={AgreementOptions.NO}>
                            <LocalizedStrict id="support-create-entity-dropdown-choose-no">
                                <span>No</span>
                            </LocalizedStrict>
                        </MenuItem>
                    </FormikDropdown>
                </LocalizedStrict>
                <LocalizedStrict id="support-create-entity-alert-title" attrs={{ title: true }}>
                    <StandardAlertInfo title="An agreement owner owns the agreement with FacilityNet and will receive related invoices. For this reason we need invoice details for agreement owners." />
                </LocalizedStrict>
            </Stack>
        </>
    )
}
